export type { MyCoursesWithRulesProps } from './types';

export { default as MyCoursesWithRules } from './LazyMyCoursesWithRules';
